/* eslint-disable import/no-dynamic-require */

/* eslint-disable global-require */
import { Icon24Done } from '@vkontakte/icons';
import { Image, RichCell, Text } from '@vkontakte/vkui';
import { useStoreMap, useUnit } from 'effector-react';
import { memo } from 'react';
import {
  $currentNominationName, $secondStageVotes, INominee, SecondStageVotesT, setSecondStageLabel, setSecondStageVote
} from 'src/entity/Pretendents';

import bridge from '@vkontakte/vk-bridge';
import { AppPanels } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import { classNames } from 'src/shared/lib/helpers/classNames';
import { CustomButton } from 'src/shared/ui/custom-button';
import styles from './styles.module.scss';

export interface ISecondStageVoitingCard extends INominee {
  image: string;
}

export const SecondStageVoitingCard = memo(
  ({
    nomineeId,
    nomineeLabel,
    image,
    nomineeGroupName
  }: ISecondStageVoitingCard) => {
    const [
      currentNominationName,
      onSetSecondStageVote,
      onSetActivePanel,
      onSetSecondStageLabel
    ] = useUnit([
      $currentNominationName,
      setSecondStageVote,
      setActivePanel,
      setSecondStageLabel
    ]);

    const currentChoose = useStoreMap({
      store: $secondStageVotes,
      fn: secondStageVotes => {
        if (!currentNominationName) return false;
        return secondStageVotes?.[currentNominationName] === nomineeId;
      },
      keys: []
    });

    if (!currentNominationName || !nomineeId) return null;

    const onCellClickHandler = () => {
      onSetSecondStageVote({
        [currentNominationName]: nomineeId
      } as SecondStageVotesT);

      onSetSecondStageLabel({
        [currentNominationName]: nomineeLabel
      } as SecondStageVotesT);
      onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);

      // @ts-ignore
      bridge.send('VKWebAppSendCustomEvent', {
        event: 'project_click',
        screen: 'nominationsCard',
        json: JSON.stringify({
          nomination: nomineeGroupName,
          project: nomineeLabel
        })
      });
    };

    return (
      <RichCell
        multiline
        onClick={onCellClickHandler}
        className={
          currentChoose
            ? classNames(styles.cell, {}, [styles.currentChoose])
            : styles.cell
        }
        before={(
          <Image
            size={96}
            src={image}
          />
        )}
        actions={(
          <CustomButton
            customMode={currentChoose ? 'success' : 'primary'}
            className={styles.button}
            size='m'
          >
            Выбрать
          </CustomButton>
        )}
        after={currentChoose && <Icon24Done className={styles.icon} />}
      >
        <Text weight='2' className={styles.title}>
          {nomineeLabel}
        </Text>
      </RichCell>
    );
  }
);
